import RolesUserPage from './RolesUserPage';

export default RolesUserPage;
